// Cookie configuration for React app
const cookieMaxAge = 604800;
const cookiePath = "/";
const sameSite: "strict" | "lax" | "none" = "strict";
const cookieSecure = true;

export const LANGUAGE_COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year

export interface CookieOptions {
  httpOnly?: boolean;
  path?: string;
  sameSite?: "strict" | "lax" | "none";
  maxAge?: number;
  secure?: boolean;
}

export const cookieOptions: CookieOptions = {
  httpOnly: true,
  path: cookiePath,
  sameSite: sameSite,
  maxAge: cookieMaxAge,
  secure: cookieSecure,
}; 

export const COOKIE_NAME = "mlbauthToken";
export const REFRESH_TOKEN_NAME = "mlbRefreshToken";
export const SESSION_KEY = "mlbSessionKey";
export const SIDEBAR_COOKIE_NAME = "mlbSidebarState";
export const LANGUAGE_COOKIE_NAME = "mlbLanguage";
